<template>
  <v-card>
    <v-card-item>
      <v-row>
        <v-col>
          <v-skeleton-loader type="heading"/>
        </v-col>
      </v-row>
      <v-row>
        <v-divider v-if="$vuetify.display.mdAndUp"/>
      </v-row>
      <v-row>
        <v-col v-if="$vuetify.display.mdAndUp" cols="6">
          <v-skeleton-loader class="car-card-image-skeleton-loader" :height="$vuetify.display.lgAndUp ? 450 : 400"
                             type="image"/>
        </v-col>
        <v-col cols="12" md="6">
          <v-row>
            <v-col v-if="$vuetify.display.smAndDown" cols="12">
              <v-skeleton-loader type="image"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <p class="text-h6">Specification</p>
              <v-skeleton-loader
                  class="car-card-title-skeleton-loader"
                  type="text"
              />
              <v-skeleton-loader
                  class="car-card-title-skeleton-loader"
                  type="text"
              />
              <v-skeleton-loader
                  class="car-card-title-skeleton-loader"
                  type="text"
              />
              <v-skeleton-loader
                  class="car-card-title-skeleton-loader"
                  type="text"
              />
              <v-skeleton-loader
                  class="car-card-title-skeleton-loader"
                  type="text"
              />
              <v-skeleton-loader
                  class="car-card-title-skeleton-loader"
                  type="text"
              />
              <v-skeleton-loader
                  class="car-card-title-skeleton-loader"
                  type="text"
              />
            </v-col>
            <v-col cols="12" md="1">
              <v-divider
                  class="fill-height"
                  :vertical="$vuetify.display.mdAndUp"/>
            </v-col>
            <v-col
                cols="12"
                md="5"
                class="text-center"
            >
              <h3 class="text-center font-weight-bold">
                Price(exw.)
                <v-tooltip text="The price paid for the product ex-works (i.e. when it leaves the factory)">
                  <template v-slot:activator="{ props }">
                    <v-btn
                        v-bind="props"
                        icon="mdi-help"
                        size="x-small"
                        variant="plain"
                        class="pb-1"
                    />
                  </template>
                </v-tooltip>
              </h3>
              <v-skeleton-loader class="car-card-title-skeleton-loader" type="text"/>
              <v-skeleton-loader class="car-card-title-skeleton-loader" type="text"/>
              <v-skeleton-loader class="car-card-title-skeleton-loader" type="text"/>
              <p class="text-center font-weight-regular text-subtitle-2 mb-3">(Price in Korea)</p>
              <v-row>
                <v-spacer :cols="3" :lg="4"/>
                <v-col :cols="5" :sm="7" :lg="4">
                  <v-skeleton-loader class="d-flex text-center" type="button"/>
                </v-col>
                <v-spacer :cols="3" :lg="4"/>
              </v-row>
              <v-skeleton-loader type="text"/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-divider/>
      </v-row>
      <v-row>
        <v-divider/>
      </v-row>
      <v-row>
        <v-col cols="12">
          <p class="text-h6">Similar cars</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-row :no-gutters="true">
            <v-col
                cols="12"
            >
              <v-skeleton-loader type="heading"/>
            </v-col>
            <v-col
                cols="12"
            >
              <v-skeleton-loader type="chip@3"/>
            </v-col>
            <v-col
                cols="12"
                align-self="center"
            >
              <v-skeleton-loader
                  class="car-item-image-skeleton-loader"
                  height="150"
                  type="image"
              />
            </v-col>
            <v-col
                cols="12"
            >
              <v-row :no-gutters="true">
                <v-col>
                  <v-skeleton-loader type="paragraph"/>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="2">
          <v-row :no-gutters="true">
            <v-col
                cols="12"
            >
              <v-skeleton-loader type="heading"/>
            </v-col>
            <v-col
                cols="12"
            >
              <v-skeleton-loader type="chip@3"/>
            </v-col>
            <v-col
                cols="12"
                align-self="center"
            >
              <v-skeleton-loader
                  class="car-item-image-skeleton-loader"
                  height="150"
                  type="image"
              />
            </v-col>
            <v-col
                cols="12"
            >
              <v-row :no-gutters="true">
                <v-col>
                  <v-skeleton-loader type="paragraph"/>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="2">
          <v-row :no-gutters="true">
            <v-col
                cols="12"
            >
              <v-skeleton-loader type="heading"/>
            </v-col>
            <v-col
                cols="12"
            >
              <v-skeleton-loader type="chip@3"/>
            </v-col>
            <v-col
                cols="12"
                align-self="center"
            >
              <v-skeleton-loader
                  class="car-item-image-skeleton-loader"
                  height="150"
                  type="image"
              />
            </v-col>
            <v-col
                cols="12"
            >
              <v-row :no-gutters="true">
                <v-col>
                  <v-skeleton-loader type="paragraph"/>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="text-h6">Specification details</p>
        </v-col>
      </v-row>
      <car-specification-details-skeleton/>
      <v-row>
        <v-divider/>
      </v-row>
      <v-row>
        <v-col>
          <h3>Description</h3>
          <v-skeleton-loader
              class="car-card-title-skeleton-loader"
              type="text@3"
          />
        </v-col>
      </v-row>
    </v-card-item>
  </v-card>
</template>

<script>

import CarSpecificationDetailsSkeleton from "@/components/Car/CarSpecificationDetailsSkeleton.vue";

export default {
  name: "CarCardSkeleton",
  components: {CarSpecificationDetailsSkeleton},
}
</script>

<style scoped>
::v-deep .car-card-image-skeleton-loader > * {
  height: 100%;
  display: flex;
  flex-direction: column;
}

::v-deep .car-card-image-skeleton-loader {
  flex-grow: 1;
}

::v-deep .car-card-title-skeleton-loader > * {
  margin-inline-start: 0;
}
</style>